import ModalHeader from './ModalHeader.vue'
export default ModalHeader
